import { z } from 'zod'
import { fromZodError } from 'zod-validation-error'

import { LOGIN_KEY, Login } from 'features/auth'

export function validateData(schema: z.Schema, data: unknown) {
  try {
    return schema.parse(data)
  } catch (error) {
    throw fromZodError(error as z.ZodError)
  }
}

type GetValueByKey<T extends string> = T extends typeof LOGIN_KEY
  ? Login
  : unknown
export function getLocalStorageItem<T extends string>(
  key: T,
  schema: z.Schema<GetValueByKey<T>>
): GetValueByKey<T> | undefined {
  const item = localStorage.getItem(key)

  if (!item) return undefined

  try {
    return validateData(schema, JSON.parse(item))
  } catch (error) {
    console.error(error)
    return undefined
  }
}
